/* eslint-disable import/no-cycle */
import React from "react";

import { useHistory } from "react-router-dom";

import { Dialog } from "primereact";

import { TakerModel } from "../../../../../domain/models/taker";

import { makeRemoteEconomicActivity } from "../../../../../main/factories/usecases/activity-economic/remote-activity-economic-factory";
import { makeRemoteCNAES } from "../../../../../main/factories/usecases/cnaes/remote-cnaes-factory";

import ButtonComponent from "../../../../components/button";
import FormFactory from "../../../../components/form-factory";
import { FieldsCNAES } from "./fields";

import { theme } from "../../../../styles/theme";

import toastUtils from "../../../../../utils/ToastUtils";
import ChooseModal from "../../../../components/modals/choose-modal";
import { FormFactoryContainer } from "./styles";

type PageProps = {
  setCurrentNote: (prev: any) => void;
};

const isSmallScreen = window.innerWidth < 768;

const CNAESComponent: React.FC<PageProps> = ({ setCurrentNote }) => {
  const history = useHistory();

  const [confirm, setConfirm] = React.useState<TakerModel | null>();
  const [show, setShow] = React.useState<boolean>();

  const onHide = (): void => {
    setShow(false);
  };

  const handleSubmit = async (values: any, actions: any): Promise<void> => {
    try {
      actions.setSubmitting(true);
      const cnaesResponse = await makeRemoteCNAES().create({
        cityPattern: { id: values?.city },
        code: values?.code,
        description: values?.description,
      });
      if (cnaesResponse?.id) {
        const eco = await makeRemoteEconomicActivity().create({
          cnae: {
            id: cnaesResponse?.id,
          },
          aliquot: values?.aliquot,
          code: values?.codeActivity,
          description: values?.descriptionActivity,
        });
        setCurrentNote((prev: any) => ({
          ...prev,
          cnae: cnaesResponse,
          economicActivity: eco,
        }));
      }
      toastUtils.showMessage({
        type: "success",
        message: "Salvo com Sucesso",
      });
      actions.setSubmitting(false);
    } catch (error: any) {
      actions.setSubmitting(false);
      toastUtils.showMessage({
        type: "error",
        message: `Erro ao salvar informações:${
          error?.detail || error?.userMessage
        }`,
      });
    }
  };

  return (
    <div
      className="d-flex justify-content-center mb-4 align-items-center"
      style={{ marginTop: "19px" }}
    >
      <div className="">
        <ButtonComponent
          type="button"
          title="+ Criar CNAE"
          color={theme.colors.blue100}
          backgroundColor={theme.colors.darkBlue}
          onClick={() => setShow(true)}
          border
        />
      </div>
      <Dialog
        header="Adicionar CNAES:"
        visible={!!show}
        style={{ width: isSmallScreen ? "90vw" : "70vw" }}
        headerStyle={{
          backgroundColor: theme.colors.darkBlue,
          color: theme.colors.white,
        }}
        contentStyle={{
          backgroundColor: theme.colors.darkBlue,
        }}
        footer={null}
        onHide={() => onHide()}
      >
        <FormFactoryContainer>
          <FormFactory
            groups={FieldsCNAES()}
            enbaleCountGroup
            onSubmit={async (values, actions) => {
              try {
                await handleSubmit(values, actions);
                actions.setSubmitting(false);
              } catch (error) {
                actions.setSubmitting(false);
              }
            }}
            backButton={{
              submit: "Voltar",
              submitting: "Voltando...",
              hide: true,
              onClick: () => history.goBack(),
            }}
            button={{
              submit: "Incluir CNAES",
              submitting: "Incluindo...",
              hide: false,
              backgroundColor: theme.colors.blue400,
            }}
          />
        </FormFactoryContainer>
      </Dialog>

      <ChooseModal
        text={`${confirm?.socialReason} é o seu tomador?`}
        onConfirm={() => {
          toastUtils.showMessage({
            type: "success",
            message: "Selecionado com Sucesso!",
          });
          setConfirm(null);
        }}
        onCancel={() => setConfirm(null)}
        isVisible={!!confirm}
        toggleVisibility={() => setConfirm(null)}
      />
    </div>
  );
};

export default CNAESComponent;
